import BaseMapper from '../../BaseMapper';

const EventLiveUpdateMapper = (data, context) => {
    return data;
};

export default EventLiveUpdateMapper;
